import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="min-h-screen bg-background text-text flex flex-col items-center justify-center p-4 sm:p-6 md:p-8 lg:p-10"
    >
      <motion.h1
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8, type: 'spring', stiffness: 100 }}
        className="text-7xl sm:text-8xl lg:text-9xl font-extrabold text-accent mb-4 drop-shadow-lg"
      >
        404
      </motion.h1>
      <motion.h2
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8, type: 'spring', stiffness: 100 }}
        className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary mb-4 text-center"
      >
        Ops! Parece que você se perdeu.
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
        className="text-lg sm:text-xl text-text mb-8 max-w-md text-center leading-relaxed"
      >
        A página que você está procurando não existe ou foi movida. Não se preocupe, estamos aqui para te ajudar a voltar ao caminho certo.
      </motion.p>
      <motion.button
        whileHover={{ scale: 1.05, backgroundColor: '#c38d09' }}
        whileTap={{ scale: 0.95 }}
        onClick={handleGoHome}
        className="px-8 py-3 bg-primary text-background font-semibold rounded-lg shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-75"
      >
        Voltar para o Início
      </motion.button>
    </motion.div>
  );
};

export default NotFoundPage;